module.exports = __webpack_public_path__ + "static/img/电子对账单.b0864c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronic/电子对账单.png
// module id = gFoT
// module chunks = 2